webpackJsonp([355],{

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskSettingLogPage_vue__ = __webpack_require__(2534);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bcb2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskSettingLogPage_vue__ = __webpack_require__(3266);
function injectStyle (ssrContext) {
  __webpack_require__(3264)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74bcb2a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskSettingLogPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bcb2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskSettingLogPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      logs: []
    };
  },

  computed: {
    sortedLogs: function sortedLogs() {
      var list = this.logs || [];
      return list.slice().sort(function (a, b) {
        return new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime();
      });
    }
  },
  created: function created() {
    this.fetchLog();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getAuditTaskSetting']), {
    fetchLog: function fetchLog() {
      var _this = this;

      var id = this.$route.params.id;
      this.loading = true;
      request.common('getAuditTaskSetting', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.logs = data.logs || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    getLogTypeLabel: function getLogTypeLabel(type) {
      var t = type === null || type === undefined ? '' : String(type);
      if (t === 'create') return '创建';
      if (t === 'update') return '更新';
      if (t === 'enable') return '启用';
      if (t === 'disable') return '禁用';
      return t;
    }
  })
});

/***/ }),

/***/ 3264:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3265);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("08485f71", content, true, {});

/***/ }),

/***/ 3265:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AuditTaskSettingLogPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/audit-task-setting/table"}},[_vm._v("审单管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("审单系统配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("操作日志")]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.sortedLogs,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"date","label":"时间","min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operator","label":"操作者","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作类型","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.getLogTypeLabel(scope.row.type))+"\n        ")]}}])})],1),_vm._v(" "),(!_vm.loading && (!_vm.sortedLogs || _vm.sortedLogs.length === 0))?_c('div',{staticClass:"pagination"},[_c('el-empty',{attrs:{"description":"暂无日志"}})],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-task-setting-log.dd5c3b6b9e1ba8c47ac8.js